// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {PayPalProps} from './types';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {config} from '../config';
import {loadScript} from '../utils';
import {containerTemplate} from '../container';
import {createToken, getPaymentMethods} from '../api';

export * from './types';

const namespace = 'monei-paypal';

const onLoadPaypal = async (props: PayPalProps, state: any, src: string) => {
  await loadScript(src, props.cspNonce, {namespace, cspNonce: props.cspNonce});
  const defaultStyle = {
    layout: 'horizontal',
    tagline: false
  };
  props.onLoad?.(true);
  let token: string | undefined;
  await window[namespace]
    .Buttons({
      createOrder: async () => {
        try {
          const result = await createToken({
            paymentId: props.paymentId,
            accountId: props.accountId,
            sessionId: props.sessionId,
            amount: props.amount,
            currency: props.currency,
            paymentMethod: {
              paypal: {}
            }
          });
          token = result.paymentToken;
          return result.paypal?.orderId;
        } catch (error) {
          props.onError?.(error);
          return;
        }
      },
      onApprove: function (data: any) {
        if (data.orderID) {
          props.onSubmit({token});
        } else {
          props.onError?.(data);
        }
      },
      onClick: function (_data: any, actions: any) {
        let shouldOpen = true;
        if (props.onBeforeOpen) {
          shouldOpen = props.onBeforeOpen();
        }
        if (!shouldOpen) return actions.reject();
      },
      style: {...defaultStyle, ...props.style}
    })
    .render(state.__container);
};

const options: ComponentOptionsType<PayPalProps> = {
  tag: namespace,
  url: config.paypalUrl,
  dimensions: {
    width: '100%',
    height: '0'
  },
  autoResize: {
    width: false,
    height: false
  },
  prerenderTemplate: () => undefined,
  containerTemplate: (params) => {
    params.state.__container = params.container;
    if (!params.props.accountId && !params.props.paymentId) {
      throw new Error('You need to provide paymentId or accountId');
    }
    return containerTemplate(params);
  },
  props: {
    accountId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    sessionId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    paymentId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    amount: {
      type: zoid.PROP_TYPE.NUMBER,
      required: false
    },
    currency: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    transactionType: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    cspNonce: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onBeforeOpen: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onSubmit: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    style: {
      type: zoid.PROP_TYPE.OBJECT,
      alias: 'innerStyle',
      required: false
    },
    __getConfig: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: ({props}: any) => {
        return getPaymentMethods.bind(null, props);
      }
    },
    __onLoadPayPal: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value({props, state}: {props: PayPalProps; state: any}) {
        return onLoadPaypal.bind(null, props, state);
      }
    }
  }
};

export const PayPal: MoneiComponent<PayPalProps> = zoid.create(options);
